import React from 'react';

const DisplaySchedule = ({ scheduleType }) => {
    if (!scheduleType) return null;

    const getScheduleColor = (type) => {
        if (type.includes('A')) return '#4CAF50';
        if (type.includes('B')) return '#2196F3';
        if (type.includes('Collaboration')) return '#FF9800';
        return '#9E9E9E';
    };

    return (
        <div
            className="schedule-box"
            style={{
                backgroundColor: getScheduleColor(scheduleType),
                color: 'white'
            }}
        >
            <h2>Today's Schedule</h2>
            <h1>{scheduleType}</h1>
        </div>
    );
};

export default DisplaySchedule;